/* eslint-disable no-param-reassign */
let AppDirectives = {};

AppDirectives.install = function (Vue, options) {
    Vue.directive('click-outside', {
        bind: function (el, binding, vnode) {
            el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: function (el) {
            document.body.removeEventListener('click', el.clickOutsideEvent)
        },
    });

    Vue.directive('max-length', {
        bind: function (el, binding) {
            let max_chars = binding.expression;
            let handlerInput = (e) => {
                if (e.target.innerText.trin().length > max_chars) {
                    e.target.value = e.target.value.substr(0, max_chars);
                    e.target.dispatchEvent(new CustomEvent('input'))
                }
            };
            el.addEventListener('input', handlerInput);
        }
    });
}

export default AppDirectives;
